import axios from 'axios';
import { INVITETEMPLATES_SET, INVITETEMPLATES_SET_LOADING } from '../types';
import {ENVIRONMENT_URL} from "constants/environment";

export const fetchInviteTemplatesAction = () => async (dispatch) => {
    dispatch({ type: INVITETEMPLATES_SET_LOADING, loading: true });

    try {

        const response = await axios.get(`${ENVIRONMENT_URL}/invites/invitation-templates`);
        const filteredTemplates = response.data.filter(template => template.approvalStatus !== "");
        
        dispatch({
            type: INVITETEMPLATES_SET,
            inviteTemplates: filteredTemplates,
        });
    } catch (error) {
        console.error("Error fetching invite templates:", error);
    } finally {
        dispatch({ type: INVITETEMPLATES_SET_LOADING, loading: false });
    }
};